export default __webpack_public_path__ + "static/emily-freeman-25fbdfd63bc4e9ff09e86a69084e6b1d.png";